<template>
	<!-- <div id="footer_home">
		<div class="w-100 overflow-hidden p-3 mt-3" style="border-top: 1px solid #1b60c6;">
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 p-3 float-right">
				<router-link to="/">

					<img
						:src="require('../../../assets/img/Logo_Header.svg')"
						alt="ایزی تیک"
						title="ایزی تیک"
						class="w-75"
					/>
				</router-link>
				<p
					class="text-justify rtl"
					data-aos="fade-up"
				  data-aos-duration="3000"
				>
					در ایزی تیک می‌توانید مدرس، استاد یا مربی مدنظر خود را در تمامی مقاطع تحصیلی و همه‌ی رشته‌های درسی و غیردرسی مشاهده نموده و برای دریافت آموزش بصورت حضوری یا آنلاین، جلسه‌ی تدریس خصوصی رزرو نمایید.
				</p>
			</div>
			<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 p-3 mt-3 float-right">
				<p class="bYekan text-success">
					دسترسی سریع
				</p>
				<router-link to="/aboutme">
					<btn
						type="white"
						style_btn="background: none !important;"
						text = "درباره ما"
						textClass="p-0"
					/>
				</router-link>
				<router-link to="/rules">
				<btn
					type="white"
					style_btn="background: none !important;"
					text = "شرایط و قوانین"
					textClass="p-0"
				/>
			</router-link>
			</div>
			<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 p-3 mt-3 float-right" style="font-size: 14px;">
				<p class="bYekan text-success">
					تماس با ما
				</p>
				<b>آدرس شرکت:</b>
				<p class="text-justify">خیابان شیراز جنوبی، بلوار آقا علیخانی شرقی پلاک2 طبقه 2 فناوری رهنمای دنیای آینده (فردا)</p>
				<b>تلفن:</b>
				<div style="display: flex; justify-content: space-between;">
					<p class="m-0">
						021-88625168
					</p>
					<p class="m-0">
						021-88618512
					</p>
				</div>
				<div class="" style="display: flex; justify-content: space-between;">
					<p class="m-0">
						021-88047153
					</p>
					<p class="m-0">
						021-88063416
					</p>
				</div>
				<div class="mb-3">
					<p class="m-0">
						021-88607815
					</p>
				</div>
				<b>ایمیل:</b>
				<p>
					info@ticket.siadat.net
				</p>
			</div>
			<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12 p-3 mt-3 float-right"  v-if="data.length>0">
				<p class="bYekan text-success">
					شبکه‌های اجتماعی
				</p>
				<a v-for="(d, i) in data" :key="j" v-if="d.status==2" :href="d.link" target="_blank">
					<img
						:src="require('../../../assets/img/social_network/'+d.img)"
						:alt="d.title"
						:title="d.title"
						style="width:21%; margin-left: 4%; margin-bottom: 4%;"
					/>
				</a>
				<a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=405303&Code=1nLd1Beg22jQkFwQAkUNP8LeAxdAVUnt'>
		      <img width="125" class="" referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=405303&Code=1nLd1Beg22jQkFwQAkUNP8LeAxdAVUnt' alt='' style='width:40%; cursor:pointer' Code='1nLd1Beg22jQkFwQAkUNP8LeAxdAVUnt'>
		      </a>
					<img referrerpolicy='origin' id = 'rgvjfukznbqergvjjzpeapfu' style = 'width:40%; cursor:pointer' onclick = 'window.open("https://logo.samandehi.ir/Verify.aspx?id=362375&p=xlaogvkauiwkxlaojyoedshw", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")' alt = 'logo-samandehi' src = 'https://logo.samandehi.ir/logo.aspx?id=362375&p=qftiwlbqodrfqftiyndtujyn' />

				</div>

			</div>
		</div> -->
	</template>

	<script>
		import btn from  "../../../UI/button/btn.vue";
		import { indexFinder } from  "../../../assets/library/filter.js";
		export default {
			name: 'p_home3',
			data(){
				return {
					indexFinder: indexFinder,
					settings: this.$localStorage.get('settings'),	
					data: [ 
						{ "title": "ostadbin aparat", "img": "aparat.png", "link": "https://www.aparat.com/Ostadbin", "status": 2 }, 
						{ "title": "ostadbin Youtube", "img": "Youtube.png", "link": "https://www.youtube.com/@ostadbin", "status": 2 }, 
						{ "title": "ostadbin Telegram", "img": "Telegram.png", "link": "https://t.me/+dgIruhzBzplhNWU8", "status": 2 }, 
						{ "title": "ostadbin Instagram", "img": "Instagram.png", "link": "http://Instagram.com/ostadbin", "status": 2 }, 
						{ "title": "ostadbin eitaa", "img": "eitaa.png", "link": "http://eitaa.com/ostadbin", "status": 2 }, 
						{ "title": "ostadbin Soroush", "img": "Soroush.png", "link": "http://splus.ir/ostadbin", "status": 2 } ,
						{ "title": "ostadbin Rubika", "img": "Rubika.png", "link": "https://rubika.ir/ostadbin_rubika", "status": 2 } 
					] ,
				}
			},
			components: {
				btn,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(){
				if(this.flds.length == 0){
					this.flds = this.$localStorage.get('footer_flds');
				}else {
					this.$localStorage.set('footer_flds', this.flds);
				}

				if(this.data.length == 0){
					this.data = this.$localStorage.get('footer_data');
				}else {
					this.$localStorage.set('footer_data', this.data);
				}
			},
			methods:{

			}
		}
	</script>
<style>

</style>
